import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IHandelssortimentTypeAhead } from "../handelssortiment/handelssortiment.models";
import { ILagerplats, IMottagningsplats, IMottagningsplatsTypeAheadResult } from "../kundorder/models/kundorder-detail-model";

@Injectable({
    providedIn: "root"
})
export class OrderService {
    private readonly apiClientService = inject(ApiClientService);

    searchForMottagningsplatsTypeAhead(input: string, ordertyp: string): Observable<IMottagningsplatsTypeAheadResult[]> {
        return this.apiClientService.post<any, IMottagningsplatsTypeAheadResult[]>(
            "typeahead/mottagningsplats",
            { input: input,
                kundordertyp: ordertyp }, false, null, ApiClientService.JsonHeader);

    }

    getMottagningsplats(id: number): Observable<IMottagningsplats> {
        return this.apiClientService.get<IMottagningsplats>(
            `Kundorder/GetMottagningsplatsById/${id}`, true);

    }

    getLagerplatser(mottagningsplats: IMottagningsplats): Observable<ILagerplats[]> {
        if (mottagningsplats.lagerplatser) {
            return of(mottagningsplats.lagerplatser);
        }
        return this.getMottagningsplats(mottagningsplats.id).pipe(map(m => m.lagerplatser), tap(l => mottagningsplats.lagerplatser = l));
    }

    searchForHandelssortimentTypeAhead(input: string, forProduktion = true, forInmatning: boolean = null): Observable<IHandelssortimentTypeAhead[]> {
        return this.apiClientService.post<any, IHandelssortimentTypeAhead[]>("typeahead/handelssortiment", {
            query: input,
            forInmatning: forInmatning,
            forProduktion: forProduktion
        }, false, null, ApiClientService.JsonHeader);
    }

    checkExtrarraderRegelverk(violId: string, mottagningsplatsId: number): Observable<boolean> {
        return this.apiClientService.get<boolean>(
            `administration/styrtabeller/checkExtrarraderRegelverk?violId=${violId}&mottagningsplatsId=${mottagningsplatsId}`,
            false);
    }

}
